import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsUnblindingRequestTypeServices } from "../../../../APIServices/EIWRS/UnblindManagement/eiwrsUnblindingRequestTypeServices";

const AddNewStudyUnblindingRequestType = ({ getEIWRSUnblindingRequestTypeData }) => {
  let { studyId } = useParams();
  const [requestType, setRequestType] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const addNewEIWRSUnblindingRequestType = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.requestType = requestType;
    let data = await eiwrsUnblindingRequestTypeServices.addNewEIWRSUnblindingRequestType(
      userData
    );
    if (data?.statusCode === 200) {
      setRequestType("");
      getEIWRSUnblindingRequestTypeData()
    }
    setButtonLoader(false);
  };

  useEffect(() => {
    setRequestType("");
  }, []);

  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Request Type{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setRequestType(e.target.value)}
          value={requestType}
          className="br3"
          placeholder="Enter Request Type"
          QuanrantineRequestType="text"
        />
      </Form.Group>
      <div className="text-end">
        <button
          disabled={!requestType || buttonLoader}
          onClick={addNewEIWRSUnblindingRequestType}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm"/> Adding...
            </div>
          ) : (
            "Add Request Type"
          )}
        </button>
      </div>
    </div>
  );
};

export default AddNewStudyUnblindingRequestType;
